import { render } from "./PantryRecommendView.vue?vue&type=template&id=57f5e2c9&ts=true"
import script from "./PantryRecommendView.vue?vue&type=script&lang=ts"
export * from "./PantryRecommendView.vue?vue&type=script&lang=ts"

import "./PantryRecommendView.vue?vue&type=style&index=0&id=57f5e2c9&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__